/**
 * Emoji representativo da experiência musical — placeholder reconhecível quando
 * ainda não há foto real (sobretudo no modo criança, onde a imagem comunica).
 * Mapa por nome (instrumentos comuns); cai pro tipo da experiência.
 */
import type { TipoExperiencia } from "./types";

const semAcento = (s: string) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim();

const POR_NOME: Record<string, string> = {
  tambor: "🥁",
  tamborim: "🥁",
  bateria: "🥁",
  caixa: "🥁",
  pandeiro: "🪘",
  atabaque: "🪘",
  bongo: "🪘",
  conga: "🪘",
  chocalho: "🪇",
  maraca: "🪇",
  maracas: "🪇",
  ganza: "🪇",
  reco: "🪇",
  "reco-reco": "🪇",
  agogo: "🔔",
  sino: "🔔",
  sinos: "🔔",
  triangulo: "🔔",
  campainha: "🔔",
  violao: "🎸",
  guitarra: "🎸",
  cavaquinho: "🎸",
  ukulele: "🎸",
  baixo: "🎸",
  piano: "🎹",
  teclado: "🎹",
  sanfona: "🪗",
  acordeao: "🪗",
  flauta: "🎶",
  apito: "🎶",
  gaita: "🎶",
  voz: "🎤",
  canto: "🎤",
  microfone: "🎤",
  cancao: "🎵",
  musica: "🎵",
  playlist: "🎧",
  fone: "🎧",
  radio: "📻",
  xilofone: "🎼",
  metalofone: "🎼",
  dança: "💃",
  danca: "💃",
  movimento: "💃",
};

const POR_TIPO: Record<TipoExperiencia, string> = {
  cancao: "🎵",
  instrumento: "🥁",
  improviso: "🎶",
  playlist: "🎧",
  atividade: "💃",
};

export function emojiExperiencia(
  nome?: string | null,
  tipo?: TipoExperiencia | null,
): string {
  if (nome) {
    const n = semAcento(nome);
    if (POR_NOME[n]) return POR_NOME[n];
    for (const palavra of n.split(/\s+/)) {
      if (POR_NOME[palavra]) return POR_NOME[palavra];
    }
  }
  if (tipo && POR_TIPO[tipo]) return POR_TIPO[tipo];
  return "🎵";
}
